import React, { useState, useEffect, useContext, useRef } from "react";
import { Table, notification, Steps, Button, Radio, Icon, Modal } from "antd";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";

import { GlobalContext } from "../../app/providers/GlobalState";

import { noimage } from "../../assets";

import SearchBar from "../../features/Turmas/_Aux/ProcurarTurma";
import Header from "../../User/Header";
import FormTransferencias from "./Forms/Transferencias";
import FormAnular from "./Forms/Anular";
import RadioGroup from "antd/es/radio/group";
import moment from "moment/moment";
import { ArrowCircleLeft } from "iconsax-react";

import { downloadFile, generateFileUrl } from "../../shared/utils/fileDownloader";

const confirm = Modal.confirm;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Transferencias = form => {
    const [pesquisa, setPesquisa] = useState("");
    const [pagination, setPagination] = useState({
        pageSize: 10,
        current: 1,
        total: 0
    });
    const [alunoSelecionado, setAlunoSelecionado] = useState(undefined);
    const [alunos, setAlunos] = useState([]);
    const [loading, setLoading] = useState(false);
    const { Step } = Steps;
    const [current, setCurrent] = useState(0);
    const [tipoTransferencia, setTipoTransferencia] = useState("remanejamento");
    const [tipo, setTipo] = useState(undefined);
    const [dataTansferencia, setDataTansferencia] = useState(moment());
    const [dataAnular, setDataAnular] = useState(moment());
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [estabelecimentoSelecinado, setEstabelecimentoSelecinado] = useState(undefined);
    const [edicoes, setEdicoes] = useState([]);
    const [edicaoSelecinado, setEdicaoSelecinado] = useState(undefined);
    const [turmas, setTurmas] = useState([]);
    const [turmaSelecinada, setTurmaSelecinada] = useState(undefined);
    const [disciplinas, setDisciplinas] = useState([]);
    const [indeterminate, setIndeterminate] = useState(false);
    const [todasDisciplinas, setTodasDisciplinas] = useState(true);
    const [disciplinasSelecionadas, setDiscipinasSelecionadas] = useState([]);
    const [tipoDocumento, setTipoDocumento] = useState(1);
    const [fileList, setFileList] = useState([]);
    const [nomeAluno, setNomeAluno] = useState("");

    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const formRef = useRef();

    const handleCheckForm = () => {
        if (formRef.current) {
            formRef.current.validateFields((err, values) => {
                if (!err) {
                    setCurrent(current + 1); // Avança para o próximo passo
                } else {
                    console.error("Erros no formulário:", err);
                }
            });
        }
    };

    const steps = ["Operaçao", "Procurar Aluno", "Dados do Processo", "Resumo"];

    const next = () => {
        if (current === 2) {
            handleCheckForm();
        } else {
            setCurrent(current + 1);
        }
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const handleChangeRadio = event => {
        setTipoTransferencia(event.target.value);
        setPesquisa("");
        setAlunos([]);
        setTipo(undefined);
        setDataTansferencia(moment());
        setDiscipinasSelecionadas([]);
        setIndeterminate(false);
        setTodasDisciplinas(false);
        setTipoDocumento(1);
        setFileList([]);
        setLoading(false);
    };

    const context = useContext(GlobalContext);

    const search = e => {
        if (e.key === "Enter") {
            setPesquisa(e.target.value);
        }
    };

    const clearSearch = () => {
        setPesquisa("");
        setAlunoSelecionado(undefined);
        setAlunos([]);
    };

    const total = () => {
        setLoading(true);

        axios({
            method: "get",
            url: "/api/gestao-transferencias/total",
            params: {
                pesquisa,
                organismoId: context.estabelecimento.id
            }
        })
            .then(response => {
                setPagination({
                    pageSize: 10,
                    current: 1,
                    total: response.data
                });
                carregarAlunos();
            })
            .catch(() => {
                setLoading(false);
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os alunos");
            });
    };

    const carregarAlunos = () => {
        if (!loading) setLoading(true);

        axios({
            method: "get",
            url: "/api/gestao-transferencias/listar",
            params: {
                pesquisa,
                pageSize: pagination ? pagination.pageSize : 10,
                page: pagination ? pagination.current : 1,
                organismoId: context.estabelecimento.id
            }
        })
            .then(response => {
                const dados = response.data.map(aluno => ({
                    key: aluno.id,
                    nome: aluno.nome,
                    numero: aluno.numero,
                    imagem: aluno.foto ? aluno.foto : noimage,
                    escolas: aluno.escolas.length > 0 ? aluno.escolas.join(", ") : "Sem escola associada",
                    semEscola: aluno.escolas.length === 0
                }));

                setLoading(false);
                setAlunos(dados);
            })
            .catch(error => {
                setLoading(false);
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os alunos");
            });
    };

    const carregarEstabelecimentos = () => {
        axios({
            method: "get",
            url: "/api/gestao-transferencias/estabelecimentos"
        })
            .then(response => {
                setEstabelecimentos(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os estabelecimentos");
            });
    };

    const handleChangeSelectEstabelecimento = estabelecimento => {
        // form.resetFields();
        setEstabelecimentoSelecinado(estabelecimento);
        setTurmaSelecinada(undefined);
    };

    const handleChangeTodas = event => {
        formRef.current.resetFields();
        setTodasDisciplinas(event.target.checked);
        setDiscipinasSelecionadas(event.target.checked ? disciplinas.map(item => item.id) : []);
        setIndeterminate(false);
    };

    const handleChangeSelectTipo = tipo => {
        setTipo(tipo);
        setEstabelecimentoSelecinado(undefined);
        setEdicaoSelecinado(undefined);
    };

    const handleChangeSelect = tipo => {
        setTipo(tipo);
    };

    const handleChangeSelectTurma = turma => {
        // form.resetFields();
        setTurmaSelecinada(turma);
        setTodasDisciplinas(true);
        setDiscipinasSelecionadas([]);
        setIndeterminate(false);
    };

    const handleChangeSelectDisciplinas = disciplinasSelecionadas => {
        formRef.current.resetFields();
        setTodasDisciplinas(disciplinasSelecionadas.length === disciplinas.length);
        setDiscipinasSelecionadas(disciplinasSelecionadas);
        setIndeterminate(!!disciplinasSelecionadas.length && disciplinasSelecionadas.length < disciplinas.length);
    };

    const carregarEdicoes = () => {
        axios({
            method: "get",
            url: "/api/gestao-transferencias/edicoes"
        })
            .then(response => {
                setEdicoes(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os estabelecimentos");
            });
    };

    const handleChangeSelectEdicao = edicao => {
        setEdicaoSelecinado(edicao);
        setEstabelecimentoSelecinado(context.estabelecimento.id);
        setTurmaSelecinada(undefined);
    };

    const handleChangeTipo = e => {
        setTipoDocumento(e.target.value);
    };

    const handlerChangeFileList = e => {
        setFileList(e);
    };

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                setLoading(true);
            }
        });
    };

    const handleChangeDataAnular = dataAnular => {
        setDataAnular(dataAnular);
    };

    const carregarTurmas = () => {
        axios({
            method: "get",
            url: "/api/gestao-transferencias/turmas",
            params: {
                utilizadorId: alunoSelecionado,
                estabelecimentoId: estabelecimentoSelecinado,
                edicaoId: edicaoSelecinado
            }
        })
            .then(response => {
                setTurmas(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os estabelecimentos");
            });
    };

    const carregarDisciplinas = () => {
        axios({
            method: "get",
            url: "/api/gestao-transferencias/disciplinas",
            params: {
                turmaId: turmaSelecinada,
                perfilId: context.perfil.id
            }
        })
            .then(response => {
                const disciplinas = response.data;
                setDisciplinas(disciplinas);
                setDiscipinasSelecionadas(disciplinas.map(item => item.id));
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os estabelecimentos");
            });
    };

    const AlunoCard = ({ nome, numero, imagem }) => (
        <div className="aluno-card">
            <div className="aluno-foto">
                <img src={imagem} alt={`Foto de ${nome}`} />
            </div>
            <div className="aluno-info">
                <span className="aluno-nome">{nome}</span>
                <span className="aluno-numero">{numero}</span>
            </div>
        </div>
    );

    const gerarResumo = () => {
        const disciplinasNomes = disciplinas
            .filter(disciplina => disciplinasSelecionadas.includes(disciplina.id))
            .map(disciplina => disciplina.nome);

        let donwloadLink = "Nenhum documento anexado";
        if (fileList.length > 0) {
            const file = fileList[0];
            const fileUrl = generateFileUrl(file);

            donwloadLink = (
                <Link to="#" title="Descarregar" onClick={() => downloadFile(file?.name, fileUrl)}>
                    {file?.name}
                </Link>
            );
        }

        const resumo = {
            aluno: nomeAluno,
            tipoTransferencia: tipoTransferencia.charAt(0).toUpperCase() + tipoTransferencia.slice(1).toLowerCase(),
            tipoEspecifico: tipo,
            estabelecimento: (estabelecimentoSelecinado && estabelecimentos.find(x => x.id === estabelecimentoSelecinado)?.nome) || "",
            edicao: (edicaoSelecinado && edicoes.find(x => x.id === edicaoSelecinado)?.nome) || "",
            turma: (turmaSelecinada && turmas.find(x => x.id === turmaSelecinada)?.nome) || "",
            disciplinas: disciplinasNomes.length > 0 ? disciplinasNomes.join(", ") : "",
            dataTransferencia: tipoTransferencia === "anular" ? dataAnular.format("DD-MM-YYYY") : dataTansferencia.format("DD-MM-YYYY"),
            documento: donwloadLink
        };

        return resumo;
    };

    const handleChangeData = dataTansferencia => {
        setDataTansferencia(dataTansferencia);
    };

    const resetEstados = () => {
        setPesquisa("");
        setPagination({
            pageSize: 10,
            current: 1,
            total: 0
        });
        setAlunoSelecionado(undefined);
        setAlunos([]);
        setLoading(false);
        setCurrent(0);
        setTipoTransferencia("remanejamento");
        setTipo(undefined);
        setDataTansferencia(moment());
        setDataAnular(moment());
        setEstabelecimentos([]);
        setEstabelecimentoSelecinado(undefined);
        setEdicoes([]);
        setEdicaoSelecinado(undefined);
        setTurmas([]);
        setTurmaSelecinada(undefined);
        setDisciplinas([]);
        setIndeterminate(false);
        setTodasDisciplinas(true);
        setDiscipinasSelecionadas([]);
        setTipoDocumento(1);
        setFileList([]);
        setNomeAluno("");
    };

    const guardar = () => {
        if (!loading) setLoading(true);

        let item = new FormData();
        item.append("alunoSelecionado", alunoSelecionado);
        item.append("tipoTransferencia", tipoTransferencia);
        item.append("tipoEspecifico", tipo);
        if (estabelecimentoSelecinado) item.append("estabelecimentoId", estabelecimentoSelecinado);
        if (edicaoSelecinado) item.append("edicaoId", edicaoSelecinado);
        if (turmaSelecinada) item.append("turmaId", turmaSelecinada);
        if (disciplinasSelecionadas.length > 0)
            disciplinasSelecionadas.forEach(id => {
                item.append("disciplinasIds", id);
            });
        item.append("data", tipoTransferencia === "anular" ? dataAnular.toISOString() : dataTansferencia.toISOString());
        if (fileList.length > 0) item.append("documento", fileList[0]);

        axios({
            method: "post",
            url: "/api/gestao-transferencias/guardar",
            data: item
        })
            .then(response => {
                let mensagemSucesso;
                if (tipoTransferencia === "remanejamento") {
                    mensagemSucesso = "Operação de remanejamento realizada com sucesso! Pretende importar as notas do aluno?";
                } else if (tipoTransferencia === "transferencia") {
                    if (tipo === "entrada")
                        mensagemSucesso = "Operação de transferencia realizada com sucesso! Pretende importar as notas do aluno?";
                    else mensagemSucesso = "Operação de transferencia realizada com sucesso!";
                } else {
                    mensagemSucesso = "Matrícula anulada com sucesso!";
                }

                resetEstados();

                if (tipoTransferencia === "remanejamento" || (tipoTransferencia === "transferencia" && tipo === "entrada"))
                    confirm({
                        title: mensagemSucesso,
                        okText: "Sim",
                        okType: "Não",
                        onOk: () => {
                            sessionStorage.setItem("alunoId", alunoSelecionado);
                            sessionStorage.setItem("turmaOrigemId", response?.data);
                            sessionStorage.setItem("turmaDestinoId", turmaSelecinada);

                            // sessionStorage.removeItem("backUrl");

                            setRedirectLink("/transferencias/importar-notas");
                            setRedirect(true);
                        },
                        onCancel: () => {
                            const backUrl = sessionStorage.getItem("backUrl");

                            if (backUrl) {
                                setRedirectLink(backUrl);
                                setRedirect(true);
                            }
                        }
                    });
                else openNotificationWithIcon("success", "Sucesso", mensagemSucesso);
            })
            .catch(error => {
                setLoading(false);

                let mensagemErro = error?.response?.data;
                if (!mensagemErro) {
                    if (tipoTransferencia === "remanejamento") {
                        mensagemErro = "Falha ao realizar a operação de entrada.";
                    } else if (tipoTransferencia === "transferencia") {
                        mensagemErro = "Falha ao realizar a operação de saída.";
                    } else {
                        mensagemErro = "Falha ao anular a matrícula.";
                    }
                }

                openNotificationWithIcon("error", "Erro", mensagemErro);
            });
    };

    const montarConteudo = current => {
        if (current === 0)
            return (
                <div>
                    <RadioGroup onChange={handleChangeRadio} value={tipoTransferencia}>
                        <Radio value="remanejamento">Remanejamento</Radio>
                        <Radio value="transferencia">Transferência</Radio>
                        <Radio value="anular">Anular</Radio>
                    </RadioGroup>
                </div>
            );
        else if (current === 1)
            return (
                <>
                    <div className="filtros">
                        <div className="bloco-esquerda">
                            <SearchBar
                                style={{ width: "100%" }}
                                pesquisa={pesquisa}
                                tem_placeholder
                                placeholder="Procurar"
                                HandleKeyPress={search}
                                resetCaixaProcura={clearSearch}
                            />
                        </div>
                    </div>
                    <Table
                        className="tabela-alunos"
                        loading={{
                            spinning: loading,
                            indicator: (
                                <div className="loading-data-table">
                                    <div className="loading" />
                                </div>
                            )
                        }}
                        columns={colunas}
                        dataSource={alunos}
                        pagination={pagination}
                        onChange={handleChangeTable}
                        locale={{ emptyText: "Não existem dados!" }}
                        onRow={record => ({
                            onClick: () => {
                                setAlunoSelecionado(record.key);
                                setNomeAluno(record.nome);
                                setCurrent(current + 1);
                            }
                        })}
                    />
                </>
            );
        else if (current === 2) {
            return tipoTransferencia === "anular" ? (
                <FormAnular
                    tipo={tipo}
                    dataAnular={dataAnular}
                    handleChangeSelect={handleChangeSelect}
                    handleChangeDataAnular={handleChangeDataAnular}
                    handleSubmit={handleSubmit}
                    ref={formRef}
                    transferido={alunoSelecionado?.transferido}
                    fileList={fileList}
                    setFileList={setFileList}
                />
            ) : (
                <FormTransferencias
                    alunoSelecionado={alunoSelecionado}
                    alunoSemEscola={alunos.find(a => a.key === alunoSelecionado)?.semEscola}
                    tipoTransferencia={tipoTransferencia}
                    dataTansferencia={dataTansferencia}
                    handleChangeData={handleChangeData}
                    handleChangeSelectEstabelecimento={handleChangeSelectEstabelecimento}
                    estabelecimentos={estabelecimentos}
                    edicoes={edicoes}
                    tipo={tipo}
                    handleChangeSelectEdicao={handleChangeSelectEdicao}
                    handleChangeTodas={handleChangeTodas}
                    handleChangeSelectDisciplinas={handleChangeSelectDisciplinas}
                    handleChangeSelectTipo={handleChangeSelectTipo}
                    handleChangeSelectTurma={handleChangeSelectTurma}
                    handleChangeTipo={handleChangeTipo}
                    estabelecimentoSelecinado={estabelecimentoSelecinado}
                    edicaoSelecinado={edicaoSelecinado}
                    turmaSelecinada={turmaSelecinada}
                    turmas={turmas}
                    disciplinas={disciplinas}
                    disciplinasSelecionadas={disciplinasSelecionadas}
                    todasDisciplinas={todasDisciplinas}
                    indeterminate={indeterminate}
                    tipoDocumento={tipoDocumento}
                    handlerChangeFileList={handlerChangeFileList}
                    fileList={fileList}
                    setFileList={setFileList}
                    ref={formRef}
                />
            );
        } else {
            const tipos = {
                remanejamento: "Remanejamento",
                transferencia: "Transferência",
                anular: "Anular"
            };

            const opcoesMap = {
                remanejamento: [
                    { value: "remanejamento", descricao: "Remanejamento a partir de outra turma" },
                    { value: "escola", descricao: "Transferência a partir de outra Escola da Rede" },
                    { value: "indefinido", descricao: "Transferência a partir de outra Rede" }
                ],
                transferencia: [
                    { value: "entrada", descricao: "Transferência de Entrada" },
                    { value: "escola", descricao: "Transferência para outra escola" },
                    { value: "indefinido", descricao: "Transferência sem definição de instituição" }
                ]
            };

            const { aluno, tipoTransferencia, tipoEspecifico, estabelecimento, edicao, turma, disciplinas, dataTransferencia, documento } =
                resumo;

            const tipo = tipoTransferencia.toLowerCase();
            const opcoes = opcoesMap[tipo];
            const descricaoTipo = opcoes?.find(o => o.value === tipoEspecifico)?.descricao || tipoEspecifico;

            return (
                <div className="bloco-resumo">
                    <h3>Resumo das Informações</h3>
                    <div>
                        <p>
                            <strong>Aluno:</strong> {aluno}
                        </p>
                        <p>
                            <strong>Operação:</strong> {tipos[tipo]}
                        </p>
                        <p>
                            <strong>{tipo === "anular" ? "Motivo da anulação" : "Tipo"}:</strong> {descricaoTipo}
                        </p>
                        {estabelecimento && (
                            <p>
                                <strong>Estabelecimento:</strong> {estabelecimento}
                            </p>
                        )}
                        {edicao && (
                            <p>
                                <strong>Edição:</strong> {edicao}
                            </p>
                        )}
                        {turma && (
                            <p>
                                <strong>Turma:</strong> {turma}
                            </p>
                        )}
                        {disciplinas && (
                            <p>
                                <strong>Disciplinas:</strong> {disciplinas}
                            </p>
                        )}
                        <p>
                            <strong>Data da operação:</strong> {dataTransferencia}
                        </p>
                        <p>
                            <strong>Documento:</strong> {documento}
                        </p>
                    </div>
                </div>
            );
        }
    };

    const handleChangeTable = pagination => {
        setPagination(prev => {
            const updated = { ...prev, current: pagination.current };
            return updated;
        });
    };

    useEffect(() => {
        carregarEstabelecimentos();
        carregarEdicoes();

        const propsString = sessionStorage.getItem("transferenciasProps");
        if (!propsString) return;

        const { current, tipo, aluno } = JSON.parse(propsString);
        if (aluno) {
            setCurrent(current);
            setTipoTransferencia(tipo);
            setAlunoSelecionado(aluno.id);
            setNomeAluno(aluno.nome);
        }
    }, []);

    useEffect(() => {
        if (pesquisa && context.estabelecimento.id) total();
    }, [pesquisa, context?.estabelecimento?.id]);

    useEffect(() => {
        if ((estabelecimentoSelecinado, edicaoSelecinado)) carregarTurmas();
    }, [estabelecimentoSelecinado, edicaoSelecinado]);

    useEffect(() => {
        if (turmaSelecinada) carregarDisciplinas();
    }, [turmaSelecinada]);

    const resumo = gerarResumo();

    const colunas = [
        {
            title: "Aluno",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => <AlunoCard nome={record.nome} numero={record.numero} imagem={record.imagem} />
        },
        {
            title: "Escolas",
            dataIndex: "escolas",
            key: "escolas"
        }
    ];

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo="Transferências de alunos" />
            <div className="container container-body">
                <div className="bloco-conteudo">
                    <div className="filtros filtros-desktop" style={{ justifyContent: "right" }}>
                        <Link className="botao-voltar2" to={sessionStorage.getItem("backUrl") ?? "/utilizador"}>
                            <ArrowCircleLeft size={34} />
                        </Link>
                    </div>
                    <div>
                        <Steps current={current} className="step">
                            {steps.map(step => (
                                <Step key={step} title={step} />
                            ))}
                        </Steps>

                        <div style={{ margin: "40px 0" }}>
                            <div className="steps-content">{montarConteudo(current)}</div>
                        </div>

                        <div className="steps-action">
                            {current < steps.length - 1 && (
                                <>
                                    <Button type="primary" onClick={() => next()} disabled={current === 1 && !alunoSelecionado}>
                                        Avançar
                                    </Button>
                                </>
                            )}

                            {current === steps.length - 1 && (
                                <Button type="primary" onClick={guardar} disabled={loading}>
                                    {loading && <Icon type="loading" />}
                                    Guardar
                                </Button>
                            )}

                            {current > 0 && (
                                <Button style={{ marginLeft: 8 }} onClick={() => prev()}>
                                    Voltar
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Transferencias;
